import DispatchDashboard from "./DispatchDashboard";

export default DispatchDashboard;